/* istanbul ignore file */
// eslint-disable-next-line import/prefer-default-export
export const ConversionType = {
  NONE: 0,
  VOLTAGE: 1,
  AIR_FLOW: 2,
};
